export const API_END_POINT = '//' + window.location.host + '/api';
export const WORDPRESS_AJAX_END_POINT = '//' + window.location.host + '/wp-admin/admin-ajax.php';
export const PATCH_UPLOAD_DIR = window.location.protocol + '//' + window.location.host + '/wp-content/uploads/patch-files/';



// WEBPACK FOOTER //
// ./src/constants.js